import React, { PropsWithChildren, useCallback, useMemo, useState } from "react";

import { PasteOptionsWidget } from "./components/PasteOptionsWidget";
import { PasteDialogContext, PasteOptionsRequest } from "./PasteDialogContext";

export const PasteDialogProvider: React.FC<PropsWithChildren<unknown>> = ({ children }) => {
  const [activeRequest, setActiveRequest] = useState<PasteOptionsRequest | null>(null);

  const showPasteOptions = useCallback((req: PasteOptionsRequest) => {
    setActiveRequest(req);
  }, []);

  const handleKeepFormatting = useCallback(() => {
    setActiveRequest(null);
  }, []);

  const handlePlainText = useCallback(() => {
    const req = activeRequest;
    setActiveRequest(null);
    req?.onPlainText?.();
  }, [activeRequest]);

  const handleCancel = useCallback(() => {
    const req = activeRequest;
    setActiveRequest(null);
    req?.onCancel();
  }, [activeRequest]);

  const value = useMemo(() => ({ showPasteOptions }), [showPasteOptions]);

  return (
    <PasteDialogContext.Provider value={value}>
      {children}
      {activeRequest && (
        <PasteOptionsWidget
          anchorRect={activeRequest.anchorRect}
          onKeepFormatting={handleKeepFormatting}
          onPlainText={handlePlainText}
          onCancel={handleCancel}
        />
      )}
    </PasteDialogContext.Provider>
  );
};
